import React from 'react'
// libs
import styled from 'styled-components'
import { useRouter } from 'hooks/useRouter'
// context
import { CreateReviewBLContext } from 'containers/Review/CreateReview/layers/BL'
// types
import { IPlan } from 'types/graphql'
// themes
import { colors } from 'themes'
// views
import { Wrapper, InnerWrapper, PlanTitle, PlanInfo, TitleWrapper, Title, DecorativeElement } from './view'
// utils
import { darken } from 'polished'

// styled
const StyledLink = styled.div`
  color: ${colors.blue500};
  cursor: pointer;
  font-weight: bold;
  margin-left: auto;

  &:hover {
    color: ${darken(0.1, colors.blue500)};
  }
`

interface IProps {
  isLinkedPlans?: boolean
  isSubPlans?: boolean
  onPlanClick?: (plan?: IPlan) => void
  parentPlan?: IPlan
  plans?: IPlan[]
}

const PlansList: React.FunctionComponent<IProps> = ({ isLinkedPlans, isSubPlans, onPlanClick, parentPlan, plans }) => {
  const { isReview } = React.useContext(CreateReviewBLContext)

  const router = useRouter()

  let title = 'Parent plan'

  if (isSubPlans) {
    title = 'Sub plans'
  }
  if (isLinkedPlans) {
    title = 'Other plans'
  }

  const getOwner = (plan: IPlan) => {
    if (plan.ownedByPosition) {
      return plan.ownedByPosition.description
    } else if (plan.ownedByUser) {
      return `${plan.ownedByUser.firstName} ${plan.ownedByUser.lastName}`
    }
    return 'N/A'
  }

  const onLinkClick = (plan: IPlan, e: React.MouseEvent) => {
    e.stopPropagation()

    router.push({
      pathname: `/plans/${plan.companyId}/edit/${plan.id}`,
      query: {
        parentId: plan.parentPlanId
      }
    })
  }

  return (
    <Wrapper>
      <TitleWrapper>
        <DecorativeElement />
        <Title>{title}</Title>
        <DecorativeElement />
      </TitleWrapper>

      {parentPlan ? (
        <InnerWrapper onClick={() => onPlanClick()} $isReview={isReview}>
          <PlanTitle>{parentPlan.name}</PlanTitle>
          <PlanInfo>{`${parentPlan.planType.description}, ${getOwner(parentPlan)}`}</PlanInfo>
          <StyledLink onClick={(e) => onLinkClick(parentPlan, e)}>GO TO PLAN</StyledLink>
        </InnerWrapper>
      ) : (
        plans.map((plan) => (
          <InnerWrapper key={plan.id} onClick={() => onPlanClick(plan)} $isReview={isReview}>
            <PlanTitle>{plan.name}</PlanTitle>
            <PlanInfo>{`${plan.planType.description}, ${getOwner(plan)}`}</PlanInfo>
            <StyledLink onClick={(e) => onLinkClick(plan, e)}>GO TO PLAN</StyledLink>
          </InnerWrapper>
        ))
      )}
    </Wrapper>
  )
}

export default PlansList
